/** Convert a data URL to raw bytes + extracted MIME type */
export function dataUrlToBytes(dataUrl: string): { bytes: Uint8Array; mimeType: string } {
  const [header, b64] = dataUrl.split(',');
  const mimeMatch = header.match(/data:([^;]+)/);
  const mimeType = mimeMatch ? mimeMatch[1] : 'application/octet-stream';
  if (!b64) return { bytes: new Uint8Array(0), mimeType };
  const binary = atob(b64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
  return { bytes, mimeType };
}

/** Nullable variant with try-catch (used by previsSaver) */
export function dataUrlToUint8Array(dataUrl: string): Uint8Array | null {
  try {
    const { bytes } = dataUrlToBytes(dataUrl);
    return bytes.length > 0 ? bytes : null;
  } catch {
    return null;
  }
}
